function collapsible(): void {
    const selector = "[data-js-collapsible]"
    const openClass = "is-open"
    const hoverClass = "headroom--collapsible-hover"

    function handleClickOutside(e: Event) {
        e.stopPropagation()
        const collapsibles = getAllCollapsibles()
        const eventTarget = e.target as HTMLElement
        collapsibles.forEach((collapsible: HTMLElement) => {
            const targetElement = document.getElementById(collapsible.getAttribute("aria-controls"))

            if (!targetElement.contains(eventTarget) && !collapsible.contains(eventTarget)) {
                close(collapsible)
            }
        })
    }

    function getAllCollapsibles() {
        return Array.from(document.querySelectorAll(selector))
    }

    function indicateOpenStateOnParent(el: HTMLElement) {
        const parentId = el.dataset.jsCollapsibleParentId
        const parentIndicatorClass = el.dataset.jsCollapsibleParentIndicatorClass
        const mainHeaderId = "header"
        const mainHeaderClass = el.dataset.jsCollapsibleMainHeaderClass

        if (!(parentId && mainHeaderId && parentIndicatorClass && mainHeaderClass)) return

        const parent = document.getElementById(parentId)
        const mainHeader = document.getElementById(mainHeaderId)

        if (!(parent && mainHeader)) return

        if (parent.querySelectorAll(`.${openClass}`).length > 0) {
            parent.classList.add(parentIndicatorClass)
            mainHeader.classList.add(mainHeaderClass)
        } else {
            parent.classList.remove(parentIndicatorClass)
            mainHeader.classList.remove(mainHeaderClass)
        }
    }

    function close(el: HTMLElement) {
        const targetElement = document.getElementById(el.getAttribute("aria-controls"))
        const collapsibleBodyClass = el.dataset.jsCollapsibleBodyClass

        if (collapsibleBodyClass) {
            document.body.classList.remove(collapsibleBodyClass)
        }

        el.setAttribute("aria-expanded", "false")
        targetElement.classList.remove(openClass)

        indicateOpenStateOnParent(el)
    }

    function toggleExpandedState(el: HTMLElement) {
        const isExpanded = el.getAttribute("aria-expanded") === "true"
        const collapsibleBodyClass = el.dataset.jsCollapsibleBodyClass

        if (collapsibleBodyClass) {
            document.body.classList.toggle(collapsibleBodyClass)
        }

        el.setAttribute("aria-expanded", isExpanded ? "false" : "true")
    }

    function toggleTargetNodeVisibility(el: HTMLElement) {
        el.classList.toggle(openClass)
    }

    function addEventListeners() {
        const collapsibles = getAllCollapsibles()
        const mainHeaderElement = document.getElementById("header") as HTMLElement

        collapsibles.forEach((collapsible: HTMLElement) => {
            const targetElement = document.getElementById(collapsible.getAttribute("aria-controls"))

            collapsible.addEventListener("click", function (e): void {
                e.preventDefault()

                toggleExpandedState(e.currentTarget as HTMLElement)
                toggleTargetNodeVisibility(targetElement)
                indicateOpenStateOnParent(e.currentTarget as HTMLElement)
            })

            const parentNavItem = collapsible.closest(".nav-main__item")

            if (parentNavItem) {
                parentNavItem.addEventListener("mouseenter", function () {
                    mainHeaderElement.classList.add(hoverClass)
                })

                parentNavItem.addEventListener("mouseleave", function () {
                    mainHeaderElement.classList.remove(hoverClass)
                })
            }
        })

        window.addEventListener("click", handleClickOutside)
    }

    function init() {
        addEventListeners()
    }

    init()
}

export default collapsible
